import { render } from "./Floatable.vue?vue&type=template&id=74dd767c&scoped=true"
import script from "./Floatable.vue?vue&type=script&lang=js"
export * from "./Floatable.vue?vue&type=script&lang=js"

import "./Floatable.vue?vue&type=style&index=0&id=74dd767c&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-74dd767c"

export default script